import { Box, Card, Stack, Step, StepLabel, Stepper } from '@mui/material';

/**
 * Card dos wizards de cadastro (produtor e jurado): stepper no topo, conteúdo do
 * passo e barra de navegação opcional no rodapé. Vai dentro do AuthLayout `wide`.
 *
 * - `steps`: rótulos dos passos; `activeStep`: índice visual atual.
 * - `actions`: botões da barra inferior (ex.: Voltar / Próximo). Sem actions, sem barra.
 */
export default function WizardCard({ steps, activeStep, actions, children }) {
  return (
    <Card sx={{ width: '100%', overflow: 'hidden' }}>
      <Box sx={{ px: { xs: 2, md: 4 }, pt: 3, pb: 2.5, borderBottom: 1, borderColor: 'divider' }}>
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={{
            '& .MuiStepLabel-label': { display: { xs: 'none', sm: 'block' }, fontSize: '0.8125rem' },
            '& .MuiStepLabel-label.Mui-active': { fontWeight: 600 },
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      <Box sx={{ px: { xs: 2, md: 4 }, py: { xs: 3, md: 4 }, minHeight: 280 }}>{children}</Box>

      {actions && (
        <Box sx={{ px: { xs: 2, md: 4 }, py: 2, borderTop: 1, borderColor: 'divider', bgcolor: 'grey.50' }}>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            {actions}
          </Stack>
        </Box>
      )}
    </Card>
  );
}
